import { useState } from "react";
import * as yup from "yup";
import Loader from "../../../../components/Loader";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useNavigationGuard from "../../../../hooks/useNavigationGuard";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateHandleUnsaveNavigation } from "../../../../utilities/handleUnsaveNavigation";
import { HandleUnsaveNavigationWithFun } from "../../../../utilities/handleUnsaveNavigationWithFun";
import { Box, Grid2, TextField } from "@mui/material";
import style from "../Subject.module.css";
import {
  formatDateWithoutTime,
  validDateRegex,
} from "../../../../utilities/helper";
import CustomSwitch from "../../../../components/CustomSwitch/CustomSwitch";

const UnblindSubject = () => {
  const [load, setLoad] = useState(false);
  const [subjectDetails, setSubjectDetails] = useState({
    subjectName: "",
    subjectNumber: "",
    subjectStatus: "",
    attributes: [],
  });

  const unblindSubjectSchema = yup.object().shape({
    unblindSubject: yup.boolean(),
  });

  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const id = useLocation()?.state?.id;
  const role = localStorage.getItem("role");

  const { subjectName, subjectNumber, subjectStatus, attributes } =
    subjectDetails;

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const handleUnSaveWithFun = HandleUnsaveNavigationWithFun();

  const {
    handleSubmit,
    control,
    formState: { isDirty },
  } = useForm({
    resolver: yupResolver(unblindSubjectSchema),
    defaultValues: {
      unblindSubject: false,
    },
  });

  useNavigationGuard(isDirty);

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button
              className="bread-crumbs-btn"
              onClick={(e) => handleUnsaveNavigation(e, isDirty, "", navigate)}
            >
              Home
            </button>
            {" | "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => {
                handleUnSaveWithFun(
                  e,
                  isDirty,
                  () => navigate("/subject"),
                  () => {}
                );
              }}
            >
              Subject Management
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => {
                handleUnSaveWithFun(
                  e,
                  isDirty,
                  () =>
                    navigate("/update-subject", {
                      state: {
                        id: id,
                      },
                    }),
                  () => {}
                );
              }}
            >
              {subjectName}
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              to="/subject-randomization-treatment"
            >
              Unblind Subject
            </button>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>

          <Box
            component="form"
            autoComplete="off"
            sx={{ height: "auto", width: "100%" }}
            onSubmit={handleSubmit(() => {})}
          >
            <Grid2
              container
              alignItems="start"
              flexDirection={"column"}
              justifyContent={"space-between"}
              sx={{ width: "100%", margin: "0 auto" }}
              gap={1}
            >
              <Grid2 size={{ xl: 8, md: 8, lg: 8, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">Subject Number</p>
                  <TextField
                    fullWidth
                    size="small"
                    disabled={true}
                    type={"text"}
                    value={subjectNumber}
                  />
                </div>
              </Grid2>

              <Grid2 size={{ xl: 8, md: 8, lg: 8, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">Subject Status</p>
                  <TextField
                    fullWidth
                    size="small"
                    disabled={true}
                    type={"text"}
                    value={subjectStatus}
                  />
                </div>
              </Grid2>
              <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
                {attributes && attributes.length > 0 && (
                  <div
                    className={style?.subjectDetailMainContainer}
                    style={{
                      margin: "20px 0px",
                    }}
                  >
                    {attributes?.map((item) => (
                      <div
                        className={style?.subjectDetailOuterContainer}
                        key={item?.keyName}
                      >
                        <span className={style?.subjectDetailName}>
                          {item?.label}
                        </span>
                        <span className={style?.subjectDetailValue}>
                          {validDateRegex.test(item?.value)
                            ? formatDateWithoutTime(item?.value)
                            : item?.value}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </Grid2>
              <Grid2 size={{ xl: 8, md: 8, lg: 8, sm: 12, xs: 12 }}>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <p>
                    Are you sure you would like to Unblind this Subject's
                    treatment?
                  </p>
                  <Controller
                    name="unblindSubject"
                    control={control}
                    defaultValue={false}
                    render={({ field }) => (
                      <CustomSwitch
                        isSwitch={field.value}
                        setSwitch={(val) => field.onChange(val)}
                      />
                    )}
                  />
                </div>
              </Grid2>
            </Grid2>
            <Grid2
              alignItems={"end"}
              justifyContent="end"
              container
              gap={3}
              sx={{ marginTop: "2%" }}
            >
              <Grid2 item md={6}>
                <button
                  type="button"
                  className="create-btn-outlined"
                  onClick={(e) => {
                    e.preventDefault();
                    handleUnSaveWithFun(
                      e,
                      isDirty,
                      () =>
                        navigate("/update-subject", {
                          state: {
                            id: id,
                          },
                        }),
                      () => {}
                    );
                  }}
                >
                  Cancel
                </button>
              </Grid2>
              <Grid2 item md={6}>
                <button type="submit" className="create-btn">
                  Save
                </button>
              </Grid2>
            </Grid2>
          </Box>
        </div>
      )}
    </>
  );
};

export default UnblindSubject;
